export const CHART_FOCUS_CLASSES =
  "[&_.recharts-surface:focus-visible]:rounded-sm [&_.recharts-surface:focus-visible]:outline-2 [&_.recharts-surface:focus-visible]:outline-offset-2 [&_.recharts-surface:focus-visible]:outline-focus [&_.recharts-surface:focus-visible]:outline-solid";
